import React from 'react';
import slider1 from '../../assets/holi.png';
import slider2 from '../../assets/girls.png';
import slider3 from '../../assets/teej24.jpeg'
import slider4 from '../../assets/freshman.jpeg'

import './Slider.css';

const sliders = [slider3, slider2, slider1,slider4];

function Slider() {
  return (
    <div
      id="carouselsAutoplaying"
      className="carousel slide"
      data-bs-ride="carousel"
      data-bs-interval="7000">
      <div className="carousel-inner">
        {sliders.map((slider, index) => (
          <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={index}>
            <img src={slider} className="sliderImage" alt={`Slider ${index + 1}`} />
          </div>
        ))}
      </div>
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#carouselsAutoplaying"
        data-bs-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#carouselsAutoplaying"
        data-bs-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
}
export default Slider;
